package com.fireavert.units.shared.data_models

enum class UnitStatus {
    Online,
    Offline,
    Error,
    NeverInstalled
}
